// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"0f004b05","450":"1ad839a2","866":"81b07ff6","953":"173c54d8"}[chunkId] + ".chunk.js";
};